import React, { useState, useEffect } from 'react';
import { Flashbar, FlashbarProps } from '@amzn/awsui-components-console';
import { useStore } from '../../../../stores/store';

const NavigationFlashbar: React.FC = () => {
	const { navigationErrors } = useStore();
	const [visibleErrorIds, setVisibleErrorIds] = useState<string[]>([]);

	useEffect(() => {
		const newErrorIds = navigationErrors.map((error) => error.id);

		setVisibleErrorIds((prev) => {
			const updated = [...prev];

			newErrorIds.forEach((id) => {
				if (!updated.includes(id)) {
					updated.push(id);
				}
			});

			return updated.filter((id) => newErrorIds.includes(id));
		});
	}, [navigationErrors]);

	const handleDismiss = (id: string) => {
		setVisibleErrorIds((prev) => prev.filter((errorId) => errorId !== id));
	};

	const displayedErrors = navigationErrors.filter((error) =>
		visibleErrorIds.includes(error.id)
	);

	if (displayedErrors.length === 0) {
		return null;
	}

	const items: FlashbarProps.MessageDefinition[] = displayedErrors.map((error) => ({
		type: error.type,
		content: error.message,
		dismissible: true,
		onDismiss: () => handleDismiss(error.id),
		id: error.id,
	}));

	return <Flashbar items={items} />;
};

export default NavigationFlashbar;
